import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { createMessagesWebSocket } from "./api";
import { features } from "../config/features";

const MessagesContext = createContext(null);

export function MessagesProvider({ children }) {
    const { isAuthenticated } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!isAuthenticated || !features.messaging) {
            setUnreadCount(0);
            return undefined;
        }

        let active = true;
        const stream = createMessagesWebSocket(
            (count) => {
                if (active) {
                    setUnreadCount(count);
                }
            },
            (message) => {
                window.dispatchEvent(new CustomEvent("pm:new_message", { detail: message }));
            },
        );

        return () => {
            active = false;
            if (stream) {
                stream.close();
            }
        };
    }, [isAuthenticated]);

    const value = useMemo(() => ({ unreadCount, setUnreadCount }), [unreadCount]);
    return <MessagesContext.Provider value={value}>{children}</MessagesContext.Provider>;
}

export function useMessages() {
    const ctx = useContext(MessagesContext);
    if (!ctx) {
        throw new Error("useMessages must be used within MessagesProvider");
    }
    return ctx;
}
